import { definePreset } from "@primeuix/themes"
import Lara from "@primeuix/themes/lara"

// Directives PrimeVue
import Tooltip from "primevue/tooltip"

// Services PrimeVue
import ToastService from "primevue/toastservice"

const MyPresent = definePreset(Lara, {
    primitive: {
        blue: {
            900: "#051833",
            800: "#092754",
            700: "#1C2B53",
            600: "#407390",
            500: "#006BCE",
            400: "#1D6EE7",
            300: "#82A8BD",
            200: "#A2D2FD",
            100: "#F3F8FF",
        },
        gray: {
            950: "#000000",
            900: "#151515",
            800: "#051833",
            300: "#D1D5DB",
            200: "#E3E3E3",
            150: "#DFE7EF", // ← niveau intermédiaire inventé
            100: "#F5F5F5",
            50: "#FFFFFF",
        },
        teal: {
            400: "#3FFFD1",
            500: "#A1EC7E",
        },
    },
    semantic: {
        primary: {
            100: "{blue.100}",
            200: "{blue.200}",
            300: "{blue.300}",
            400: "{blue.400}",
            500: "{blue.500}",
            600: "{blue.600}",
            700: "{blue.700}",
            800: "{blue.800}",
            900: "{blue.900}",
        },
        teal: {
            400: "{teal.400}",
            500: "{teal.500}",
        },
        colorScheme: {
            default: "light",
            // light: {
            //     primary: {
            //         color: "{blue.500}",
            //         contract: "#ffffff",
            //         hoverColor: "{blue.800}",
            //         activeColor: "{blue.800}",
            //     },
            //     highlight: {
            //         background: "{blue.900}",
            //         focusBackground: "{blue.200}",
            //         color: "#ffffff",
            //         focusColor: "{blue.700}",
            //     },
            // },
        },
    },
    components: {
        message: {
            colorScheme: {
                light: {
                    info: {
                        color: "{blue.700}",
                    },
                },
            },
        },
        button: {
            css: () => `
                .p-button-link {
                    --p-button-label-font-weight: 600;
                    min-width: auto!important;
                    white-space: nowrap;
                    font-size: 1.25rem;

                    --p-button-padding-x: 0.5rem;
                    --p-button-padding-y: 0.5rem;
                    
                    .p-button-label {
                        font-family: "Bricolage Grotesque", sans-serif!important;
                    }
                }

                .p-button-link.p-button-sm {
                    --p-button-sm-font-size: 1rem;
                    font-size: var(--p-button-sm-font-size);
                }

                .p-button-link:not(:disabled):hover {
                    text-decoration-line: underline;
                    text-decoration-style: solid;
                    text-decoration-skip-ink: auto;
                    text-decoration-thickness: auto;
                    text-underline-offset: auto;
                    text-underline-position: from-font;
                }

            

                .p-button:not(.p-button-link):not(.p-button-icon-only) {
                  min-width: 15rem;
                  height: 3.25rem;
                  border-radius: 3.125rem;

                  --p-button-padding-x: 1.5rem;
                  --p-button-padding-y: 0.875rem;
                  
                }
                .p-button .p-button-label {
                    font-family: "Montserrat", sans-serif;
                }
                  
            `,
            colorScheme: {
                light: {
                    primary: {
                        background: "{primary.500}",
                        color: "#ffffff",
                        borderColor: "{primary.500}",
                        hover: {
                            background:
                                "linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), #1D6EE7",
                            color: "#ffffff",
                            borderColor: "{primary.500}",
                        },
                        active: {
                            background:
                                "linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), #1D6EE7",
                            color: "#ffffff",
                            borderColor: "{primary.500}",
                        },
                    },
                    secondary: {
                        background: "transparent",
                        color: "{primary.900}",
                        borderColor: "{primary.900}",
                        hover: {
                            background: "{primary.100}",
                            color: "{primary.900}",
                            borderColor: "{primary.900}",
                        },
                        active: {
                            background: "{primary.100}",
                            color: "{primary.900}",
                            borderColor: "{primary.900}",
                        },
                    },
                    outlined: {
                        primary: {
                            color: "#ffffff",
                            border: {
                                color: "#ffffff",
                            },
                        },
                    },
                    link: {
                        color: "#ffffff",
                        hover: {
                            color: "{primary.400}",
                        },
                        active: {
                            color: "{primary.400}",
                        },
                    },
                },
            },
        },
    },
})

export const HomeysTheme = {
    theme: {
        preset: MyPresent,
        ripple: true,
        options: {
            prefix: "p",
            darkModeSelector: false || "none",
            cssLayer: false,
        },
    },
}

export const PRIMVEVUE_DIRECTIVES: { [key: string]: any } = {
    tooltip: Tooltip,
    toast: ToastService,
}

export const PRIMVEVUE_SERVICE: { [key: string]: any } = {
    toast: ToastService,
}
